<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">Contacten</h2>
            </div>
            <div class="box-body form-horizontal">
                <div class="form-group" v-for="contacttype in getContactTypes">
                    <ProjectFormContact
                        @detach-contact="detachContactHandler"
                        :contactType="contacttype"
                        :open-search="openSearch"
                    />
                </div>
            </div>
            <div class="overlay" v-show="isLoading">
                <i class="fa fa-refresh fa-spin" />
            </div>
        </div>
        <crm-selector :on-selected="selectContact" />
    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import CrmSelector from '../../Common/Selectors/CrmSelector';
    import ProjectFormContact from './Contact';
    import Hub from '../../../Hub';

    export default {

        components: {
            CrmSelector,
            ProjectFormContact,
        },

        computed: {
            ...mapGetters([
                "getContacts",
                "getContactTypes",
                "isLoading",
            ]),
        },

        data() {
            return {
                forItem:'',
            }
        },

        methods: {

            ...mapActions([
                "addContact",
                "setContacts",
                'detachContact',
            ]),

            closeSearch() {
                // Clear foritem again
                this.forItem = '';
                Hub.$emit("close-contact-selector");
            },

            detachContactHandler(contactType) {
                this.detachContact(contactType.id);
                this.$snotify.success("Contact is losgekoppeld. Sla het formulier op.")
            },

            openSearch(forItem) {
                // Store the item which its for
                this.forItem = forItem;
                // Fire event to open the contact selector
                Hub.$emit("open-contact-selector");
            },

            selectContact(contact){
                // Add the contact
                this.addContact({
                    contacttypeid: this.forItem.id,
                    contact: {
                        company_name: contact.company_name,
                        full_name: contact.full_name,
                        uuid: contact.uuid,
                        is_contact: contact.isContact,
                        itemUri: contact.itemUri,
                    }
                });
                // Close the search again.
                this.closeSearch();
            },
        },

        mounted() {
        },

        name: "ProjectFormContacts",

        props: {
        }
    }

</script>
